import { Field, FieldValidator } from 'formik'
import React, { ReactNode } from 'react'
import styles from './radioFieldWTN.module.scss'
import classNames from 'classnames'

interface Props {
  name: string
  value: string
  text: ReactNode
  type?: 'radio' | 'button'
  icon?: ReactNode
  disabled?: boolean
  className?: string
  validate?: FieldValidator
}

const RadioFieldWTN = ({
  name,
  value,
  text,
  icon,
  type = 'radio',
  className = '',
  disabled,
  validate,
}: Props) => {
  if (type === 'button') {
    return (
      <label className={classNames(styles.radioButton, className)} data-formik-error={name}>
        <Field type='radio' name={name} value={value} validate={validate} />
        <span className={styles.button}>
          {icon}
          {text}
        </span>
      </label>
    )
  }
  return (
    <label
      className={classNames(styles.commonRadioLabel, className, {
        [styles.commonRadioLabelDisabled]: disabled,
      })}
      data-formik-error={name}
    >
      <Field type='radio' name={name} value={value} disabled={disabled} validate={validate} />{' '}
      <span>{text}</span>
    </label>
  )
}

export default RadioFieldWTN
